'use client';

import React, { useState, useEffect } from 'react';
import TrackItem from './TrackItem';
import styles from './TrackList.module.css';
import { useDragReorder } from '@/hooks/useDragReorder';

interface Track {
  id: number;
  title: string;
  composer: string;
  duration: string;
  slug: string;
  isFavorited?: boolean;
}

interface TrackListProps {
  tracks: Track[];
  editable?: boolean;
  onReorder?: (orderedIds: number[]) => void;
  playlistId?: number;
  isOwner?: boolean;
}

export default function TrackList({
  tracks,
  editable = false,
  onReorder,
  playlistId,
  isOwner,
}: TrackListProps) {
  const [localTracks, setLocalTracks] = useState(tracks);

  const { items, getDragProps, setItems } = useDragReorder(localTracks);

  // синхронизация при изменении входных tracks
  useEffect(() => {
    setLocalTracks(tracks);
    setItems(tracks);
  }, [tracks, setItems]);

  // уведомляем родителя о новом порядке, если редактируем
  useEffect(() => {
    if (editable) {
      onReorder?.(items.map(t => t.id));
    }
  }, [items, onReorder, editable]);

  const handleRemove = (songId: number) => {
    const updated = localTracks.filter(t => t.id !== songId);
    setLocalTracks(updated);
    setItems(updated);
  };

  return (
    <div className={styles.list}>
      {(editable ? items : localTracks).map((track, index) => (
        <div key={track.id} {...(editable ? getDragProps(index) : {})}>
          <TrackItem
            track={track}
            index={index}
            playlistId={playlistId}
            isOwner={isOwner}
            onRemove={handleRemove}
            draggable={editable}
            isDragging={false} // 👈 пока можно просто false
          />
        </div>
      ))}
    </div>
  );
}
